module.exports = __webpack_public_path__ + "static/ZenithSlabDJRColor-Regular-ba6463dbf4cc076d3e5af0a8a75a06c2.woff";